/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ads_Dialog_ConfirmInputs */

const en_directory_ads_dialog_confirm = /** @type {(inputs: Directory_Ads_Dialog_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue to payment`)
};

const zh_directory_ads_dialog_confirm = /** @type {(inputs: Directory_Ads_Dialog_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前往支付`)
};

/**
* | output |
* | --- |
* | "Continue to payment" |
*
* @param {Directory_Ads_Dialog_ConfirmInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ads_dialog_confirm = /** @type {((inputs?: Directory_Ads_Dialog_ConfirmInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ads_Dialog_ConfirmInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ads_dialog_confirm(inputs)
	return zh_directory_ads_dialog_confirm(inputs)
});
export { directory_ads_dialog_confirm as "directory.ads.dialog_confirm" }